import { jsx as _jsx } from "react/jsx-runtime";
import { BeforeYouStart } from '@/pages/before-you-start-page.component';
import { CompletePage } from '@/pages/complete-page.component';
import { DetailsFormPage } from '@/pages/details-form-page.component';
import { DinTestPage } from '@/pages/din-test-page.component';
import { HearingAidOptionsPage } from '@/pages/hearing-aid-options-page.component';
import { LandingPage } from '@/pages/landing-page.component';
import ResultCategoryPage, { ResultCategoryOutlet, } from '@/pages/result-category-page.component';
import { SelectionPage } from '@/pages/selection-page.component';
import { SetupPage, VolumeStep } from '@/pages/setup-page.component';
import { SpeakToAnExpertFormPage } from '@/pages/speak-to-an-expert-form-page.component';
import { VideoCallPage } from '@/pages/video-call-page.component';
import { Navigate } from 'react-router-dom';
import { SevereHearingLossResults } from '@/components/results-category/components/severe-hearing-loss-results.component';
import { MildHearingLossResults } from '@/components/results-category/components/mild-hearing-loss-results.component';
import { OtcBenefits } from '@/components/results-category/components/otc-hearing-aid-benefits.component';
import { ShareTheJoyOfHearing } from '@/components/results-category/components/share-the-joy-of-hearing.component';
import { NormalHearingLossResults } from '@/components/results-category/components/normal-hearing-loss-results.component';
import { Feedback } from '@/components/results-category/components/feedback/feedback.component';
import { InstructionsStep } from '@/components/hearing-test-intructions.component';
import { WelcomePage } from '@/pages/welcome-page/welcome-page.component';
export var appRoutes = [
    {
        path: '/hearing-aid-options',
        element: _jsx(HearingAidOptionsPage, {}),
    },
    { path: '/', element: _jsx(WelcomePage, {}) },
    {
        path: '/before-you-start',
        element: _jsx(BeforeYouStart, {}),
    },
    {
        path: '/setup',
        element: _jsx(SetupPage, {}),
        children: [
            {
                index: true,
                element: _jsx(Navigate, { to: "/setup/volume", replace: true }),
            },
            { path: 'volume', element: _jsx(VolumeStep, {}) },
        ],
    },
    { path: '/instructions', element: _jsx(InstructionsStep, {}) },
    { path: '/din-test', element: _jsx(Navigate, { to: "/din-test/1", replace: true }) },
    { path: '/din-test/:id', element: _jsx(DinTestPage, {}) },
    { path: '/details-form', element: _jsx(DetailsFormPage, {}) },
    {
        path: '/result-category',
        element: _jsx(ResultCategoryPage, {}),
        children: [
            {
                path: 'severe',
                element: _jsx(SevereHearingLossResults, {}),
            },
            {
                path: 'mild',
                element: _jsx(ResultCategoryOutlet, {}),
                children: [
                    {
                        index: true,
                        element: _jsx(MildHearingLossResults, {}),
                    },
                    {
                        path: 'otc-benefits',
                        element: _jsx(OtcBenefits, {}),
                    },
                ],
            },
            {
                path: 'normal',
                element: _jsx(ResultCategoryOutlet, {}),
                children: [
                    {
                        index: true,
                        element: _jsx(NormalHearingLossResults, {}),
                    },
                ],
            },
        ],
    },
    {
        path: 'feedback',
        element: _jsx(Feedback, {}),
    },
    {
        path: '/share-the-joy',
        element: _jsx(ShareTheJoyOfHearing, {}),
    },
    { path: '/complete', element: _jsx(CompletePage, {}) },
    { path: '/landing', element: _jsx(LandingPage, {}) },
    {
        path: '/speak-to-an-expert-form',
        element: _jsx(SpeakToAnExpertFormPage, {}),
    },
    { path: '/selection', element: _jsx(SelectionPage, {}) },
    { path: '/video-call', element: _jsx(VideoCallPage, {}) },
    {
        path: '/index.html',
        element: _jsx(Navigate, { to: "/", replace: true }),
    },
];
